// installCookies.js
import installFacebookAnalytics from "./installFacebookAnalytics";
import { installTikTokAnalytics } from "./installTikTokAnalytics";
import { installGoogleAnalytics } from "./installGoogleAnalytics";

export function installCookies(consent) {
  if (import.meta.env.DEV) {
    console.log("Installing cookies based on consent…");
  }

  if (consent.analytics) {
    installGoogleAnalytics(); // react-ga4 init
  }
  if (consent.marketing) {
    //installFacebookAnalytics();
    //installTikTokAnalytics();
  }

  if (import.meta.env.DEV) {
    console.log("Cookies installed");
  }
}
